$(document).ready(function () {
      $(".featured-video .video-wrapper").click(function () {
        // Use `this` to target the clicked element and its children
        $(this).find(".image-wrapper").hide();
        $(this).find(".plyr").show();
        console.log("work");
    });
    var selectedVariant = $("variant-selection.variant-selection").attr("variant");
    $("#" + selectedVariant).addClass("selectedVariant");
    var mainColorLabel = $("#colorMainLabel").text();
    $(".colorLabelFake").text(mainColorLabel);
    $(".color-variant-box").click(function () {
        var linkedVariant = $(this).attr("data-class");
        $(".color-variant-box").removeClass("selectedVariant");
        $(this).addClass("selectedVariant");
        $(linkedVariant).click();
        setTimeout(function () {
            $(".colorLabelFake").text($("#colorMainLabel").text());
        }, 500);



        var youtubeLink = $(this).attr("data-url");
        var videoThumbnail = $(this).attr("data-cover");
        if (youtubeLink) {
            var videoID = extractVideoID(youtubeLink);
            var embedURL = "https://www.youtube.com/embed/" + videoID;
          //  pauseAllIframes();
            $(".plyr__video-wrapper iframe").attr("src", embedURL);
            $(".plyr__controls").hide();
        }
        if(videoThumbnail){
            $(".video-wrapper.overlay--text_only .image-wrapper img").attr("src", videoThumbnail);
            $(".video-wrapper.overlay--text_only .image-wrapper").show();
            $(".video-wrapper.overlay--text_only").addClass("readyToPlay");
            $(".video-wrapper.overlay--text_only .plyr.plyr--full-ui").hide();
            $("button.plyr__control").hide();    
        }      

    });

    


    function extractVideoID(link) {
        var regex = /v=([A-Za-z0-9_-]+)/;
        var match = link.match(regex);

        if (match && match[1]) {
            return match[1];
        } else {
            console.error("Invalid YouTube link");
            return null;
        }
    }

    function pauseAllIframes() {
        // Pause all iframes with the class "plyr__video-wrapper"
        $(".plyr__video-wrapper iframe").each(function () {
            var iframe = $(this)[0];
            if (iframe && iframe.contentWindow && iframe.contentWindow.postMessage) {
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
        });
    }


});

if(window.innerWidth<768){
  $('#tickerTape .container').flickity({
      wrapAround: true,
      autoPlay: 2000,
      prevNextButtons: false,
      pageDots: false
  
  })
}
